import { defineComponent, h } from 'vue';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default defineComponent({
  name: 'App',
  components: {
    Bar
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
            padding: 25,
            labels: {
              font: {
                // You can specify additional font properties here if needed
              }
            }
          },
          tooltip: {
            callbacks: {
              title: () => "",
              label: function(context) {
                let label = context.dataset.label || '';
                let index = context.dataIndex;

                if (label) {
                  label += ': ';
                }

                if (context.parsed.y !== null) {
                  const currency = context.dataset.currencies ? context.dataset.currencies[index] : '';
                  const tooltipValue = context.dataset.tooltips ? context.dataset.tooltips[index] : '';

                  if (currency !== null && tooltipValue !== null) {
                    label += tooltipValue.toLocaleString() + currency;
                  }
                }

                return label;
              }
            }
          },
          datalabels: {
            display: false // Disable data labels on bars
          }
        },
        scales: {
          y: {
            position: 'left',
            grid: {
              display: true,
              color: "#e4e6e8",
            },
            ticks: {
              maxTicksLimit: 10,
              font: {
                size: 10
              },
            }
          },
          x: {
            grid: {
              display: false
            },
            ticks: {
              maxTicksLimit: 10,
              font: {
                size: 10
              },
              maxRotation: 0,
              minRotation: 0,
            }
          }
        }
      }
    };
  },
  render() {
    return h('div', { style: { height: '400px' } }, [ // Set height here if needed
      h(Bar, {
        data: this.chartData,
        options: this.options
      })
    ]);
  }
});
